/* tslint:disable */
/* eslint-disable */
/**
 * Accounts API
 * API pour la gestion des comptes utilisateurs
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConnectedUserInfosResponse,
  OperationResponse,
  UpdatePasswordCommand,
} from '../models/index';
import {
    ConnectedUserInfosResponseFromJSON,
    ConnectedUserInfosResponseToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    UpdatePasswordCommandFromJSON,
    UpdatePasswordCommandToJSON,
} from '../models/index';

export interface UpdatePasswordRequest {
    updatePasswordCommand: UpdatePasswordCommand;
}

/**
 * 
 */
export class AccountsApi extends runtime.BaseAPI {

    /**
     * Get current user infos
     */
    async getUserConnectedInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConnectedUserInfosResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/comptes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConnectedUserInfosResponseFromJSON(jsonValue));
    }

    /**
     * Get current user infos
     */
    async getUserConnectedInfo(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConnectedUserInfosResponse> {
        const response = await this.getUserConnectedInfoRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update current user password
     */
    async updatePasswordRaw(requestParameters: UpdatePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['updatePasswordCommand'] == null) {
            throw new runtime.RequiredError(
                'updatePasswordCommand',
                'Required parameter "updatePasswordCommand" was null or undefined when calling updatePassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/comptes/update-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePasswordCommandToJSON(requestParameters['updatePasswordCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Update current user password
     */
    async updatePassword(requestParameters: UpdatePasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updatePasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
